import * as React from 'react'
import { Cell, BarChart as RechartsBarChart, ResponsiveContainer } from 'recharts'

import { Bar } from '../chart/Bar'
import { ChartContext } from '../chart/ChartWrapper'
import { CursorBar } from '../chart/Cursor'
import { Tooltip } from '../chart/Tooltip'
import { YAxis } from '../chart/YAxis'
import { ChartItemColorType } from '../chart/constants'
import ChartTooltip from './ChartTooltip'
import {
  BAR_CHART_LABELS_MARGIN,
  BAR_CHART_MARGINS,
  BAR_GAP,
  BAR_WIDTH,
  CHART_HEIGHT,
  EXTRA_WIDTH,
  LABELS_WIDTH,
} from './constants'
import { ChartProps } from './types'
import { getChartDataItemKey, tickFormatter } from './utils'

export default function BarChart({ chartData, visibleAreas, columnsCount, isFullWidth }: ChartProps) {
  const chartWidth = columnsCount * BAR_WIDTH + (columnsCount - 1) * BAR_GAP + EXTRA_WIDTH
  const ChartWrapper = isFullWidth ? ResponsiveContainer : React.Fragment

  return (
    <ChartContext {...(isFullWidth ? { className: 'w-full', style: { height: CHART_HEIGHT } } : {})}>
      <ChartWrapper>
        <RechartsBarChart
          width={chartWidth}
          height={CHART_HEIGHT}
          data={chartData}
          margin={BAR_CHART_MARGINS}
          barCategoryGap={BAR_GAP / 2}
          stackOffset="sign" // because we can have negative values
        >
          <YAxis
            orientation="right"
            textAnchor="end"
            tickFormatter={tickFormatter}
            tickMargin={BAR_CHART_LABELS_MARGIN}
            width={LABELS_WIDTH}
            interval="preserveStartEnd"
          />
          <Tooltip cursor={<CursorBar numberOfDatapoints={null} />} content={<ChartTooltip isReversed />} />
          {/* Don't change the order of mapped items here, see getChartData */}
          {visibleAreas.map((area) => {
            const itemKey = getChartDataItemKey(area)
            return (
              <Bar
                key={itemKey}
                name={area.label}
                dataKey={itemKey}
                stackId="year"
                shape={undefined}
                color={area.color as ChartItemColorType}
                fill={area.color}
              >
                {chartData.map((row, index) => (
                  <Cell
                    key={index}
                    className="stroke-bg-primary stroke-[0.25px]"
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore - number[] should also be allowed type for radius, but it's not
                    radius={[row.topKey, row.bottomKey].includes(itemKey) ? [2, 2, 0, 0] : [0, 0, 0, 0]}
                  />
                ))}
              </Bar>
            )
          })}
        </RechartsBarChart>
      </ChartWrapper>
    </ChartContext>
  )
}
